import { graphql } from './graphql'
import { type SanitizedResult } from '@amzn/amp-gql'
export const trackLikesContextFrag = graphql(`
    fragment trackLikesContext on Track @_unmask {
        __typename
        id
        likesContext @include(if: $isAuthenticated) {
            liked
        }
    }
`)

export type TrackLikesContext = SanitizedResult<typeof trackLikesContextFrag>
